'use client';
import { useEffect } from 'react';

import { openFinanceLeadModalAtom } from '@core/Atoms/FinanceModal/FinanceModal.atom';
import { activeLeadFormAtom } from '@core/Atoms/Leads/ActiveLeadForm.atom';

import { useAtomValue, useSetAtom } from 'jotai';

const OpenFinanceLeadModal = () => {
  const shouldOpenFinanceLeadModal = useAtomValue(openFinanceLeadModalAtom);

  const toggleLeadForm = useSetAtom(activeLeadFormAtom);

  useEffect(() => {
    if (shouldOpenFinanceLeadModal) {
      toggleLeadForm('message-dealer-finance');
    }
  }, [shouldOpenFinanceLeadModal]);

  return null;
};

export default OpenFinanceLeadModal;
